import { render, staticRenderFns } from "./SkyShowFeiShuDocumentView.vue?vue&type=template&id=2ba0e008"
import script from "./SkyShowFeiShuDocumentView.vue?vue&type=script&lang=js"
export * from "./SkyShowFeiShuDocumentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports